<template>
    <nav>
        <ul v-if="menu && menu.length">
            <li v-for="(item, id) in menu" :key="id">
                <a :href="item.slug">{{ item.label }}</a>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        props: ['menu']
    }
</script>

<style lang="scss" scoped>

</style>
